import React, { useEffect, useState } from 'react';
import { Spinner, Table, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFuncFichaEmpleado } from '../../redux/func_ficha_empleados/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import UserHeadDetail from '../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../components/UserHeadDetailMenu';

const JobHistory = props => {

  const dispatch = useDispatch();
  const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);

  useEffect(() => {
    dispatch(getFuncFichaEmpleado(props.match.params.id, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type])

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  

  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <UserHeadDetail data={data} type={props.match.params.type} />
                <div className="my-4">
                  <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                    <div className="mt-4 mb-3">
                    <div className="d-flex aling-items-center justify-content-between px-2">
                      <h5 className="font-weight-bold text-uppercase">Historial Laboral</h5>
                      <div>
                        <span className="text-muted mr-3"><i className="material-icons">vpn_key</i> Código: {data.codigo}</span>
                        <span className="text-muted mr-3"><i className="material-icons">timer</i> Antiguedad: {parseInt(data.antiguedad_laboral)/12 > 1 ? (parseFloat(data.antiguedad_laboral)/12 - Math.floor(parseInt(data.antiguedad_laboral)/12)) ? `${parseInt(Math.floor(data.antiguedad_laboral)/12)} años ${Math.round((parseFloat(data.antiguedad_laboral)/12 - Math.floor(parseInt(data.antiguedad_laboral)/12)) * 12)} meses` :`${parseInt(data.antiguedad_laboral)/12} años`: `${parseInt(data.antiguedad_laboral)} meses`}</span>
                        <span className="text-muted"><i className="material-icons">moving</i> {data.Relacion_Laboral_List ? data.Relacion_Laboral_List[0].descripcion : 'No ingresado aún'}</span>
                      </div>
                    </div>
                    <hr className="mb-3" />
                    <div className="mt-4 mb-3">
                      {
                        data.Historial_Laboral_List ? (
                          <Table variant="dark">
                            <thead>
                              <td>Descripción</td>
                              <td>Puesto</td>
                            </thead>
                            <tbody>
                              {
                                data.Historial_Laboral_List.map(item => (
                                  <tr>
                                    <td>{item.descripcion}</td>
                                    <td>
                                      { item.puesto_list ? 
                                          item.puesto_list.map((position,index) => {
                                            if(item.puesto_list[index+1] != null){
                                                return position.descripcion + ','
                                            }
                                            return position.descripcion
                                          })
                                        : 'No ingresado aún' 
                                      }
                                    </td>
                                  </tr>
                                ))
                              }
                            </tbody>
                          </Table>
                        ): (
                          <Alert variant="info">
                            <p>No registrados aún</p>
                          </Alert>
                        )
                      }
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
    </>
  )
};
export default JobHistory
